import callApi from './crmService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/profile`;

export const getSaProfile = () => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-sa-profile-v2`
});

export const unbindSa = () => callApi({
  method: 'POST',
  endpoint: `${basePath}/unbind-sa`
});
